import { clientContactApi, getOfficeSuggestions, parentAccountApi } from '@atheneum/api'
import get from 'lodash/get'
import { computed, extendObservable } from 'mobx'

const emptyQuery = {
  keyword: '',
  page: 1,
  status: 'active',
  complianceAuditor: false,
  knowledgeManager: false,
  atheneumContactName: ''
}

class ClientContactSearchStore {
  constructor (staticData, growlStore) {
    const defaultCountry = { id: '', name: 'All countries' }

    extendObservable(this, {
      page: 1,
      staticData,
      growlStore,
      autocompleteSuggestion: '',
      officeAutocompleteSuggestion: '',
      officeSuggestion: [],
      numberOfContacts: null,
      contactsData: [],
      selectedContact: '',
      loading: false,
      error: null,
      countries: computed(() => {
        return [defaultCountry, ...this.staticData.countries]
      }),
      selectedCountry: defaultCountry,
      query: emptyQuery
    })
  }

  select (id) {
    this.selectedContact = id
  }

  searchCountry = country => {
    this.selectedCountry = country
  }

  search () {
    this.loading = true
    this.numberOfContacts = null

    this.query.account =
      get(this.autocompleteSuggestion, 'type') === 'account'
        ? this.autocompleteSuggestion.id
        : undefined
    this.query.parentAccount =
      get(this.autocompleteSuggestion, 'type') === 'parentAccount'
        ? this.autocompleteSuggestion.id
        : undefined

    this.query.office = get(this.officeAutocompleteSuggestion, 'id', undefined)
    this.query.country = get(this.selectedCountry, 'id', undefined)

    return clientContactApi.searchClients(this.query)
      .then(result => {
        const clients = result.body.hits.hits.map(e => e._source)
        this.contactsData.replace(clients)
        this.numberOfContacts = result.body.hits.total.value
      })
      .then(() => {
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  clearSearch () {
    this.query = emptyQuery
    this.autocompleteSuggestion = ''
    this.officeAutocompleteSuggestion = ''
    this.selectedCountry = ''
    this.search()
  }

  autocomplete = value => {
    if (!value) return Promise.resolve([])

    return parentAccountApi.getRecordsSuggestions(value, [
      'parentAccount',
      'account'
    ])
  }

  officeAutocomplete = value => {
    if (!value) return Promise.resolve([])
    return getOfficeSuggestions(value)
  }

  changePage (page) {
    this.query.page = page
    this.search()
  }

  autocompletePosition = value => {
    if (!value) return Promise.resolve([])
    return clientContactApi.getClientPositionSuggestions(value)
  }
}

export default ClientContactSearchStore
